'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var PropTypes = require('prop-types');
var FontIcon = require('./FontIcon.js');
var DualIcon = require('./DualIcon.js');
var Link = require('./Link.js');
var Loader = require('./Loader.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');
require('deepmerge');
require('react-svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _exp2 = function _exp2() {
  return function (_ref) {
    var fullWidth = _ref.fullWidth;
    return fullWidth ? '100%' : 'inherit';
  };
};
var _exp3 = function _exp3() {
  return function (_ref2) {
    var buttonColorOverride = _ref2.buttonColorOverride;
    return buttonColorOverride || 'var(--shared-button-primary-backgroundColor)';
  };
};
var _exp4 = function _exp4() {
  return function (_ref3) {
    var textColorOverride = _ref3.textColorOverride;
    return textColorOverride || 'var(--shared-button-primary-font-color)';
  };
};
var _exp5 = function _exp5() {
  return function (_ref4) {
    var hoverColorOverride = _ref4.hoverColorOverride;
    return hoverColorOverride || 'var(--shared-button-primary-hover-backgroundColor)';
  };
};
var _exp6 = function _exp6() {
  return function (_ref5) {
    var buttonColorOverride = _ref5.buttonColorOverride;
    return buttonColorOverride || 'var(--shared-button-secondary-border-color)';
  };
};
var _exp7 = function _exp7() {
  return function (_ref6) {
    var textColorOverride = _ref6.textColorOverride;
    return textColorOverride || 'var(--shared-button-secondary-font-color)';
  };
};
var _exp8 = function _exp8() {
  return function (_ref7) {
    var hoverColorOverride = _ref7.hoverColorOverride;
    return hoverColorOverride || 'var(--shared-button-secondary-hover-backgroundColor)';
  };
};
var StyledButton = /*#__PURE__*/react.styled('button')({
  name: "StyledButton",
  "class": "s1vx2tc1",
  propsAsIs: false,
  vars: {
    "s1vx2tc1-0": [_exp2()],
    "s1vx2tc1-1": [_exp3()],
    "s1vx2tc1-2": [_exp4()],
    "s1vx2tc1-3": [_exp5()],
    "s1vx2tc1-4": [_exp6()],
    "s1vx2tc1-5": [_exp7()],
    "s1vx2tc1-6": [_exp8()]
  }
});
var _exp10 = function _exp10() {
  return function (_ref8) {
    var fullWidth = _ref8.fullWidth;
    return fullWidth ? '100%' : 'inherit';
  };
};
var _exp11 = function _exp11() {
  return function (_ref9) {
    var buttonColorOverride = _ref9.buttonColorOverride;
    return buttonColorOverride || 'var(--shared-button-primary-backgroundColor)';
  };
};
var _exp12 = function _exp12() {
  return function (_ref10) {
    var textColorOverride = _ref10.textColorOverride;
    return textColorOverride || 'var(--shared-button-primary-font-color)';
  };
};
var _exp13 = function _exp13() {
  return function (_ref11) {
    var hoverColorOverride = _ref11.hoverColorOverride;
    return hoverColorOverride || 'var(--shared-button-primary-hover-backgroundColor)';
  };
};
var _exp14 = function _exp14() {
  return function (_ref12) {
    var buttonColorOverride = _ref12.buttonColorOverride;
    return buttonColorOverride || 'var(--shared-button-secondary-border-color)';
  };
};
var _exp15 = function _exp15() {
  return function (_ref13) {
    var textColorOverride = _ref13.textColorOverride;
    return textColorOverride || 'var(--shared-button-secondary-font-color)';
  };
};
var _exp16 = function _exp16() {
  return function (_ref14) {
    var hoverColorOverride = _ref14.hoverColorOverride;
    return hoverColorOverride || 'var(--shared-button-secondary-hover-backgroundColor)';
  };
};
var StyledAnchor = /*#__PURE__*/react.styled('a')({
  name: "StyledAnchor",
  "class": "s4tx08p",
  propsAsIs: false,
  vars: {
    "s4tx08p-0": [_exp10()],
    "s4tx08p-1": [_exp11()],
    "s4tx08p-2": [_exp12()],
    "s4tx08p-3": [_exp13()],
    "s4tx08p-4": [_exp14()],
    "s4tx08p-5": [_exp15()],
    "s4tx08p-6": [_exp16()]
  }
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ButtonStyles = ['primary', 'secondary', 'tertiary', 'quaternary', 'inline', 'tile', 'icon'];
var ButtonSizes = ['hero', 'large', 'medium', 'small'];
var ButtonIconPositions = ['left', 'right', 'top'];
var propTypes = {
  buttonStyle: PropTypes__default["default"].oneOf(ButtonStyles),
  buttonSize: PropTypes__default["default"].oneOf(ButtonSizes),
  fullWidth: PropTypes__default["default"].bool,
  iconName: PropTypes__default["default"].string,
  dualIconName: PropTypes__default["default"].string,
  iconPos: PropTypes__default["default"].oneOf(ButtonIconPositions),
  loading: PropTypes__default["default"].bool,
  loadingText: PropTypes__default["default"].string,
  to: PropTypes__default["default"].string,
  onClick: PropTypes__default["default"].func,
  onMouseEnter: PropTypes__default["default"].func,
  onMouseLeave: PropTypes__default["default"].func,
  onKeyDown: PropTypes__default["default"].func,
  onFocus: PropTypes__default["default"].func,
  anchorAttrs: PropTypes__default["default"].objectOf(PropTypes__default["default"].any),
  buttonAttrs: PropTypes__default["default"].objectOf(PropTypes__default["default"].any),
  className: PropTypes__default["default"].string,
  additionalStyles: PropTypes__default["default"].object,
  childStyles: PropTypes__default["default"].object,
  textColorOverride: PropTypes__default["default"].string,
  buttonColorOverride: PropTypes__default["default"].string,
  hoverColorOverride: PropTypes__default["default"].string,
  tooltipText: PropTypes__default["default"].string,
  flipIcon: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].any,
  ariaLabel: PropTypes__default["default"].string,
  ariaHasPopup: PropTypes__default["default"].bool,
  ariaExpanded: PropTypes__default["default"].bool,
  testId: PropTypes__default["default"].string
};
var Button = function Button(_ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$buttonStyle = _ref.buttonStyle,
    buttonStyle = _ref$buttonStyle === void 0 ? 'primary' : _ref$buttonStyle,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? 'large' : _ref$buttonSize,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    iconName = _ref.iconName,
    dualIconName = _ref.dualIconName,
    _ref$iconPos = _ref.iconPos,
    iconPos = _ref$iconPos === void 0 ? 'left' : _ref$iconPos,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$loadingText = _ref.loadingText,
    loadingText = _ref$loadingText === void 0 ? 'Loading...' : _ref$loadingText,
    anchorAttrs = _ref.anchorAttrs,
    buttonAttrs = _ref.buttonAttrs,
    className = _ref.className,
    to = _ref.to,
    _onClick = _ref.onClick,
    _onMouseEnter = _ref.onMouseEnter,
    _onMouseLeave = _ref.onMouseLeave,
    onKeyDown = _ref.onKeyDown,
    _onFocus = _ref.onFocus,
    additionalStyles = _ref.additionalStyles,
    childStyles = _ref.childStyles,
    textColorOverride = _ref.textColorOverride,
    buttonColorOverride = _ref.buttonColorOverride,
    hoverColorOverride = _ref.hoverColorOverride,
    tooltipText = _ref.tooltipText,
    locale = _ref.locale,
    flipIcon = _ref.flipIcon,
    children = _ref.children,
    testId = _ref.testId,
    ariaHasPopup = _ref.ariaHasPopup,
    ariaExpanded = _ref.ariaExpanded,
    tabIndex = _ref.tabIndex;
  var classNames = "".concat(className || '', " ").concat(buttonStyle, " ").concat(buttonSize, " ", "icon-".concat(iconPos), " ").concat(tooltipText ? 'tooltip' : '', "\n  ").concat(loading ? 'loading' : '', " ").concat(iconPos === 'top' ? 'column' : '');
  var _useState = React.useState(false),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var getIconMargin = function getIconMargin() {
    if (buttonStyle === 'icon') return '0';
    if (buttonSize === 'medium' || buttonSize === 'small') return 'var(--space-xy-xxxSmall-rem)';
    return 'var(--space-xy-xxSmall-rem)';
  };
  var getLoaderColor = function getLoaderColor() {
    if (buttonStyle === 'primary') return 'var(--shared-button-primary-loader-color)';
    if (buttonStyle === 'secondary') return 'var(--shared-button-secondary-loader-color)';
    if (buttonStyle === 'tertiary') return 'var(--shared-button-tertiary-loader-color)';
    if (buttonStyle === 'quaternary') return 'var(--shared-button-quaternary-loader-color)';
    return 'var(--color-primary-body-base)';
  };
  var isDisabled = !!(buttonAttrs !== null && buttonAttrs !== void 0 && buttonAttrs.disabled);
  var baseIconStyles = _objectSpread({
    marginLeft: "".concat(iconPos === 'right' ? getIconMargin() : 0),
    marginRight: "".concat(iconPos === 'left' ? getIconMargin() : 0),
    marginBottom: "".concat(iconPos === 'top' ? getIconMargin() : 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, flipIcon && {
    transform: 'rotate(180deg)'
  });
  var icon = /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "icon",
    children: [iconName && !dualIconName && /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
      fontSize: "".concat(buttonStyle === 'tile' ? '2.5rem' : 'inherit'),
      iconName: iconName,
      styles: _objectSpread({}, baseIconStyles)
    }), dualIconName && !iconName && /*#__PURE__*/jsxRuntime.jsx(DualIcon["default"], {
      iconName: dualIconName,
      styles: _objectSpread({
        opacity: isDisabled ? 'var(--effect-opacity-30)' : 'var(--effect-opacity-100)',
        height: '2.5rem',
        width: '2.5rem'
      }, baseIconStyles)
    })]
  });
  var content = /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [(iconPos === 'left' || iconPos === 'top') && (iconName || dualIconName) && icon, /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "button-text",
      style: childStyles,
      children: children
    }), iconPos === 'right' && (iconName || dualIconName) && icon]
  });
  var loader = /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "loader",
      children: /*#__PURE__*/jsxRuntime.jsx(Loader["default"], {
        color: getLoaderColor()
      })
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      children: loadingText
    })]
  });
  var link = /*#__PURE__*/jsxRuntime.jsx(Link["default"], {
    to: to || '',
    locale: locale,
    ariaLabel: ariaLabel,
    children: /*#__PURE__*/jsxRuntime.jsx(StyledAnchor, _objectSpread(_objectSpread({
      className: classNames,
      "data-testid": testId || 'anchor'
    }, anchorAttrs), {}, {
      style: additionalStyles,
      fullWidth: fullWidth,
      textColorOverride: textColorOverride,
      buttonColorOverride: buttonColorOverride,
      hoverColorOverride: hoverColorOverride,
      onMouseEnter: function onMouseEnter(e) {
        if (_onMouseEnter) _onMouseEnter(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (_onMouseLeave) _onMouseLeave(e);
      },
      onFocus: function onFocus(e) {
        if (_onFocus) _onFocus(e);
      },
      tabIndex: tabIndex,
      children: loading ? loader : content
    }))
  });
  var button = /*#__PURE__*/jsxRuntime.jsxs(StyledButton, _objectSpread(_objectSpread({
    className: classNames,
    type: type,
    "data-testid": testId || 'button'
  }, buttonAttrs), {}, {
    onClick: function onClick(e) {
      if (tooltipText) {
        setShowTooltip(true);
      }
      if (_onClick) {
        _onClick(e);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (_onMouseEnter) _onMouseEnter(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      if (_onMouseLeave) _onMouseLeave(e);
    },
    onKeyDown: onKeyDown,
    onFocus: function onFocus(e) {
      if (_onFocus) _onFocus(e);
    },
    style: additionalStyles,
    onMouseOut: function onMouseOut() {
      if (tooltipText) {
        setShowTooltip(false);
      }
    },
    fullWidth: fullWidth,
    textColorOverride: textColorOverride,
    buttonColorOverride: buttonColorOverride,
    hoverColorOverride: hoverColorOverride,
    "aria-label": ariaLabel,
    "aria-haspopup": ariaHasPopup,
    "aria-expanded": ariaExpanded,
    tabIndex: tabIndex,
    children: [showTooltip && /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "tooltip-text",
      children: tooltipText
    }), loading ? loader : content]
  }));
  return to ? link : button;
};
Button.propTypes = propTypes;

exports["default"] = Button;
